import { Button, Grid } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import PopupForm from "app/common/Component/Popup/PopupForm";
import TableComponent from "app/common/Component/Table/TableComponent";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import { formatMoney, getDateTime } from "app/common/LocalFunction";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

function HistoryChangeRemainPopup({
  open,
  handleClose,
  searchData,
  pageData,
  handleChangeFormSearch,
}) {
  const { t } = useTranslation();

  return (
    <PopupForm
      size="lg"
      title="Lịch sử chuyển đổi số dư"
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: searchData,
      }}
      hideSubmit
    >
      {({ values }) => {
        return (
          <>
            <Grid container spacing={1}>
              <Grid item xs={12} className="flex flex-end gap-2">
                <Grid container spacing={1} className="cards-body">
                  <Grid item xs={12} sm={3}>
                    <GlobitsDateTimePicker label="Từ ngày" name="fromDate" />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <GlobitsDateTimePicker label="Đến ngày" name="toDate" />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    md={2}
                    className="flex flex-start gap-2"
                  >
                    <Button
                      className="btn-primary"
                      type="button"
                      onClick={() => handleChangeFormSearch(values)}
                    >
                      <Search />
                      Tìm kiếm
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                className="justify-center cards-body pt-0 mt-2"
                style={{
                  zIndex: 1,
                  position: "relative",
                }}
              >
                <TableComponent
                  className=""
                  showOrdinalNumbers
                  titleNodata={t("noData")}
                  data={pageData?.content}
                  columns={[
                    {
                      field: "clientCard.code",
                      title: t("Ngày giao dịch"),
                      render: (val) => {
                        return <div>{getDateTime(val?.transationDate)}</div>;
                      },
                    },
                    {
                      field: "department.name",
                      title: t("Cơ sở giao dịch"),
                    },
                    {
                      field: "createdBy",
                      title: "Người tạo",
                    },
                    {
                      field: "quantity",
                      title: t("Nội dung giao dịch"),
                      render: (data) => (
                        <span className="cell-content">
                          <>
                            {data?.invoiceItem?.invoiceItemName
                              ? data?.invoiceItem?.invoiceItemName
                              : data?.transactionType > 0
                              ? data?.voucherItem?.voucher?.note
                              : "Cọc tiền"}
                          </>
                        </span>
                      ),
                    },
                    {
                      field: "practitioner.staffName",
                      title: t("Số tiền giao dịch"),
                      align: "right",
                      render: (data) => (
                        <span
                          className={`cell-amount ${
                            data?.transactionType > 0
                              ? "text-green"
                              : "text-red"
                          }`}
                        >
                          {data?.transactionType > 0 ? "+" : "-"}{" "}
                          {formatMoney(data?.amount)}
                        </span>
                      ),
                    },
                    {
                      field: "parentTransaction.invoiceItem.invoiceItemName",
                      title: t("Từ đơn hàng"),
                      align: "right",
                    },
                    {
                      field: "usedAmount",
                      title: "Đã dùng",
                      align: "right",
                      render: (data) => (
                        <span>{formatMoney(data?.usedAmount)}</span>
                      ),
                    },

                    {
                      field: "usedAmount",
                      title: "Còn lại",
                      align: "right",
                      render: (data) => (
                        <span>
                          {formatMoney(data?.amount - (data?.usedAmount || 0))}
                        </span>
                      ),
                    },
                  ]}
                  dataPagination={{
                    pageIndex: searchData?.pageIndex,
                    pageSize: searchData?.pageSize,
                    totalElements: pageData?.totalElements,
                    totalPages: pageData?.totalPages,
                    setPageIndex: (pageIndex) =>
                      handleChangeFormSearch({ pageIndex }),
                    setPageSize: (pageSize) =>
                      handleChangeFormSearch({ pageSize }),
                  }}
                />
              </Grid>
            </Grid>
          </>
        );
      }}
    </PopupForm>
  );
}

export default memo(observer(HistoryChangeRemainPopup));
